<template>
<div class="chapter">
<div class="inner_page">
<p class="part-h"><span>P<span class="smallcaps">ART</span> I</span></p>
<p class="part-center"><span>The Viking’s Daughter</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part1.vue?5f16335b